import { FieldFilterValue } from "@/orval/gen/model"

export function getUpdatedFilterDict(
  typeId: number,
  filterValue: FieldFilterValue,
  filterDict: { [key: string]: FieldFilterValue } | null | undefined
) {
  let newValue
  if (filterValue.values && filterValue.values.length > 0)
    newValue = { ...filterDict, [typeId]: filterValue }
  else if (filterDict) {
    const { [typeId]: _, ...rest } = filterDict
    newValue = rest
  }
  return newValue
}
